import Button from "@/components/Button";
import Dialog from "@/components/Dialog";

type DeferredEmploymentInfoModalProps = {
  open: boolean;
  onClosed: () => void;
};

/**
 * Explains why employment add/edit/delete is visible but not currently performable
 * while pending-registration employment is locked.
 */
export default function DeferredEmploymentInfoModal({ open, onClosed }: DeferredEmploymentInfoModalProps) {
  return (
    <Dialog
      open={open}
      onClosed={onClosed}
      headline="Employment Changes Unavailable"
      className="max-w-[560px] p-6 pr-2"
      hasFormElements={false}
      actions={
        <Button variant="filled" onClick={onClosed} testId="deferred-employment-info-close">
          Got It
        </Button>
      }
    >
      <div tabIndex={0} className="flex flex-col gap-3 text-sys-brand-on-surface-variant">
        <p className="text-body-medium">
          Staff employment changes in Member 360 are only available after registration completes. While this person is
          pending Associate or Affiliate registration, employment cannot be added, edited, or deleted.
        </p>
        <p className="text-body-medium">
          Once registration payment is complete, you can manage employment on this page as usual.
        </p>
      </div>
    </Dialog>
  );
}
